import { render } from "./UserGroup.vue?vue&type=template&id=12a00f36"
import script from "./UserGroup.vue?vue&type=script&lang=ts"
export * from "./UserGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script